
import urlUtil from 'url';
import qsUtil from 'qs';

export const selector = {
  query(rootState) {
    return rootState.url.query;
  }
};

export default {
  state: urlUtil.parse(window.location.href, true),
  reducers: {
    set(state, url = '') {
      return urlUtil.parse(url, true);
    }
  },

  effects: {
    async replaceQuery(query = {}, rootState) {
      const { url } = rootState;
      const newQuery = { ...query };

      const search = `?${qsUtil.stringify(newQuery)}`;
      // effect 同步的
      window.history.replaceState({}, undefined, search);

      const newUrlStr = replaceUrlQuery(url, newQuery);
      this.set(newUrlStr);

      return newUrlStr;
    },

    async setQuery(query = {}, rootState) {
      const { url } = rootState;
      const newQuery = { ...url.query, ...query };

      const search = `?${qsUtil.stringify(newQuery)}`;
      // effect 同步的
      window.history.replaceState({}, undefined, search);

      const newUrlStr = replaceUrlQuery(url, newQuery);
      this.set(newUrlStr);

      return newUrlStr;
    }
  }
};


function replaceUrlQuery(url = {}, query = {}) {
  // 为了让新的query生效，需要覆盖href，path，search，重置为默认值（undefined）
  // 如果不重置上述参数为默认值，真正加载的链接不会发生变化
  const newUrl = {
    ...url,
    query,
    href: undefined,
    path: undefined,
    search: undefined
  };
  const newUrlStr = urlUtil.format(newUrl);

  return newUrlStr;
}
